import styled from "styled-components";

export const PhoneField = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;

  @media(max-width:415px){
    flex-direction: column;
    :first-child{
      width: 100%;
    }
  }
`;

export const Dropdown = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
`;

export const PrivacyPolicyBlock = styled.div`
  height: 2rem;

  .label__block {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    color: #232c42;
    line-height: 1;
    margin: auto;
  }

  .checkbox__style {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 14px;
  }

  .privacy__link {
    text-align: left;
    color: #004581;
    font-weight: 700;
    padding-left: 0.5rem;
  }
`;

export const FormButton = styled.button`
  width: 100%;
  max-width: 23.125rem;
  color: #fff;
  background-color: #004581;
  border: 1px solid #004581;
  margin: auto;

  &:hover {
    background-color: #fff;
    color: #004581;
  }
`;
